// Dummy content for Sanggar Rias Adibah — updated with real contact + pricelist
// NOTE: BRAND is the static fallback/SEO source; BRAND_STATIC exports only SEO-critical fields.
// At runtime, useBrandData() hook merges these with Firestore data.

export const BRAND = {
  name: "Sanggar Rias Adibah",
  tagline: "Mahakarya Rias Pengantin Nusantara",
  logoUrl: "/images/icon.png",
  foundedYear: 2008,
  phone: "+62 812 8032 7569",
  whatsapp: "6281280327569",
  email: "lw5051900@gmail.com",
  address:
    "Perum Telaga Pesona Blok L26 No.3 RT 6 RW 17, Kelurahan Telaga Murni, Kecamatan Cikarang Barat, Kabupaten Bekasi, Jawa Barat 17530",
  instagram: "@sanggar_rias_adibah",
  tiktok: "@lina.wati4399",
  facebook: "lina mua cikarang",
  socials: {
    instagram: "https://www.instagram.com/sanggar_rias_adibah",
    tiktok: "https://www.tiktok.com/@lina.wati4399",
    facebook: "https://web.facebook.com/moms.adibah",
  },
};

export const HERO_IMAGES = [
  "/images/hero-4.jpeg",
  "/images/hero-6.jpeg",
  "/images/hero-5.JPEG",
];

export const ABOUT_IMAGE = "/images/about.png";

export const ABOUT_TEXTURE = "/images/about-texture.png";

// PRICE LIST — Reguler & Premium individual sessions
export const PRICELIST = {
  reguler: {
    label: "Reguler",
    subtitle: "Pilihan ringkas untuk momen istimewa",
    items: [
      {
        name: "Graduation",
        price: "150K",
        desc: "Riasan wisuda segar & tahan lama",
      },
      {
        name: "Pendamping Wisuda",
        price: "100K",
        desc: "Look natural untuk pendamping",
      },
      {
        name: "Bridesmaid",
        price: "150K",
        desc: "Tampil serasi di samping pengantin",
      },
      {
        name: "Photoshoot / Party",
        price: "100K",
        desc: "Riasan ekspresif untuk pesta & foto",
      },
    ],
  },
  premium: {
    label: "Premium Makeup",
    subtitle: "Sentuhan artisan untuk momen besar",
    items: [
      {
        name: "Graduation",
        price: "250K",
        desc: "Editorial grade graduation look",
      },
      {
        name: "Engagement",
        price: "300K",
        desc: "Rias lamaran sakral & romantis",
      },
      {
        name: "Prewedding",
        price: "350K",
        desc: "Konsep cinematic untuk pemotretan",
      },
    ],
    freebies: ["Bulu Mata", "Hijab Do", "Softlens"],
    note: "Free Softlens hanya untuk Premium Makeup",
  },
};

// Visual showcase cards (for Services bento section)
export const SERVICES = [
  {
    id: "graduation",
    title: "Graduation",
    subtitle: "Fresh · Youthful · Radiant",
    priceFrom: "150K",
    description:
      "Look wisuda yang segar dan tahan lama. Dari prosesi hingga sesi foto bersama keluarga.",
    image:
      "https://images.unsplash.com/photo-1547934659-7fa699ef3ce0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    icon: "GraduationCap",
  },
  {
    id: "engagement",
    title: "Engagement",
    subtitle: "Lembut · Romantis · Intimate",
    priceFrom: "300K",
    description:
      "Rias lamaran yang menonjolkan kecantikan natural Anda. Dewy skin & lip stain mawar tua.",
    image:
      "https://images.unsplash.com/photo-1704621354138-e124277356f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    icon: "Heart",
  },
  {
    id: "prewedding",
    title: "Prewedding",
    subtitle: "Story · Cinematic · Timeless",
    priceFrom: "350K",
    description:
      "Konsep riasan disesuaikan tema pemotretan — dari pastel romantis hingga editorial high-fashion.",
    image:
      "https://images.unsplash.com/photo-1729773173866-022d39fc6c50?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    icon: "Camera",
  },
  {
    id: "bridesmaid",
    title: "Bridesmaid",
    subtitle: "Anggun · Selaras · Glow",
    priceFrom: "150K",
    description:
      "Riasan bridesmaid yang menonjolkan tema pengantin tanpa mencuri perhatian.",
    image:
      "https://images.unsplash.com/photo-1665960212714-0dfa0702c177?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    icon: "Sparkles",
  },
  {
    id: "party",
    title: "Photoshoot & Party",
    subtitle: "Bold · Artistic · Statement",
    priceFrom: "100K",
    description:
      "Untuk gala dinner, ulang tahun, hingga pemotretan editorial dengan signature gold-glow.",
    image:
      "https://images.pexels.com/photos/37083518/pexels-photo-37083518.jpeg",
    icon: "Star",
  },
  {
    id: "wedding",
    title: "Wedding Package",
    subtitle: "Sakral · Megah · Paripurna",
    priceFrom: "2JT",
    description:
      "Paket pengantin lengkap — dari Akad Minimalis hingga Paket A dengan busana adat & pagar ayu.",
    image:
      "https://images.unsplash.com/photo-1693673300110-44baf2276ed6?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    icon: "Crown",
  },
];

export const PORTFOLIO = [
  {
    src: "https://images.unsplash.com/photo-1665960212714-0dfa0702c177?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Sari & Bagas",
    category: "Adat Jawa Solo",
    size: "tall",
  },
  {
    src: "https://images.unsplash.com/photo-1729773173866-022d39fc6c50?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Prewedding Editorial",
    category: "Studio Series",
    size: "wide",
  },
  {
    src: "https://images.pexels.com/photos/29194910/pexels-photo-29194910.jpeg",
    title: "Tania & Rendra",
    category: "Akad Cikarang",
    size: "square",
  },
  {
    src: "https://images.unsplash.com/photo-1693673300110-44baf2276ed6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Putri Solo",
    category: "Resepsi Megah",
    size: "tall",
  },
  {
    src: "https://images.pexels.com/photos/37083518/pexels-photo-37083518.jpeg",
    title: "Behind the Brush",
    category: "Editorial",
    size: "square",
  },
  {
    src: "https://images.unsplash.com/photo-1704621354138-e124277356f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Golden Hour",
    category: "Detail Shot",
    size: "wide",
  },
  {
    src: "https://images.unsplash.com/photo-1570212773364-e30cd076539e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Dewi & Arsyad",
    category: "Hijab Modern",
    size: "tall",
  },
  {
    src: "https://images.unsplash.com/photo-1547934659-7fa699ef3ce0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Palette Adibah",
    category: "Behind the Scenes",
    size: "square",
  },
];

export const TESTIMONIALS = [
  {
    name: "Annisa Pradipta",
    role: "Pengantin · Juni 2024",
    quote:
      "Riasan dari Mbak Lina benar-benar membuat saya tidak mengenali diri sendiri — dalam arti yang paling indah. Semua tamu bertanya siapa MUA-nya. Pengalaman yang tak terlupakan.",
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop",
  },
  {
    name: "Rania Hapsari",
    role: "Pengantin · Maret 2024",
    quote:
      "Detail paes, sanggul, hingga sentuhan akhir lipstik — semuanya presisi. Tim Sanggar Adibah datang tepat waktu, profesional, dan membuat hari saya terasa seperti dongeng.",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop",
  },
  {
    name: "Galuh & Bagas",
    role: "Klien Prewedding · 2024",
    quote:
      "Hasil foto prewedding kami diliput majalah pernikahan lokal. Konsep yang ditawarkan Adibah sangat fresh dan editorial. Worth every rupiah.",
    avatar:
      "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=200&h=200&fit=crop",
  },
  {
    name: "Karina Mahesa",
    role: "Pengantin · Oktober 2023",
    quote:
      "Saya kulit sensitif dan mudah jerawatan. Produk yang dipakai semuanya halal & cocok di kulit saya. Make-up bertahan dari pagi sampai malam tanpa sentuh ulang.",
    avatar:
      "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=200&h=200&fit=crop",
  },
];

// WEDDING PACKAGES — actual from price list
export const PACKAGES = [
  {
    name: "Akad Minimalis",
    tier: "Wedding Package",
    price: "2",
    unit: "Juta",
    currency: "IDR",
    tagline: "Sakral, ringkas, dan paripurna",
    features: [
      "Makeup Wedding & Hijab Do (1× Retouch)",
      "Sepasang Busana Akad",
      "Free Accecoris Nasional / Sigger",
      "Free Sepasang Selop Akad",
      "Free Softlens",
      "Free Fake Nails / Kuku Palsu",
    ],
    highlight: false,
  },
  {
    name: "Paket A",
    tier: "Wedding Package · Lengkap",
    price: "4,5",
    unit: "Juta",
    currency: "IDR",
    tagline: "Pilihan favorit pengantin Adibah",
    features: [
      "Makeup Wedding (Free 1× Retouch)",
      "1 Pasang Busana Akad",
      "1 Pasang Busana Resepsi",
      "2 Pasang Busana Orang Tua",
      "2 Makeup Ibu Pengantin",
      "Free Accecoris Adat (pilih salah satu)",
      "Free Melati Premium",
      "2 Busana Pagar Ayu + 2 Makeup Pagar Ayu",
      "Melati Adat Premium",
      "Free Fake Nails & Softlens",
    ],
    highlight: true,
  },
];

export const STATS = [
  { value: "9+", label: "Tahun Pengalaman" },
  { value: "500+", label: "Klien Puas" },
  { value: "3", label: "Sertifikat Profesional" },
  { value: "100%", label: "Signature Glam Look" },
];

export const FAQS = [
  {
    q: "Berapa lama proses booking dan trial makeup?",
    a: "Booking idealnya dilakukan 6–12 bulan sebelum hari-H. Sesi trial dilakukan 1–2 bulan sebelum acara, dan setiap paket sudah termasuk sesi trial sesuai tier.",
  },
  {
    q: "Apakah tim Adibah bisa datang ke luar kota?",
    a: "Tentu. Kami melayani pengantin dari Cikarang, Bekasi, Jakarta, hingga seluruh Indonesia. Biaya transport & akomodasi dihitung terpisah untuk lokasi di luar Jabodetabek.",
  },
  {
    q: "Produk apa saja yang Anda gunakan?",
    a: "Kami menggunakan produk halal premium — Chanel, Dior, Charlotte Tilbury, Hourglass, dan Wardah Exclusive — yang telah teruji aman untuk semua jenis kulit.",
  },
  {
    q: "Bagaimana jika saya berhijab?",
    a: "Tim kami berpengalaman dengan hijab styling modern hingga adat Sunda Hijabi & Jawa Hijabi. Tersedia konsultan khusus untuk drapping & aksesoris.",
  },
];

export const FALLBACK_CERTIFICATES = [
  {
    title: "Sertifikat MUA Profesional",
    issuer: "LSP Rias Indonesia",
    date: "2023",
    imageRef: "/images/certificate/certificate-1.jpeg",
  },
  {
    title: "Sertifikat Makeup Artist",
    issuer: "BNSP",
    date: "2024",
    imageRef: "/images/certificate/certificate-2.jpeg",
  },
  {
    title: "Sertifikat Bridal Makeup",
    issuer: "Sanggar Rias Nusantara",
    date: "2024",
    imageRef: "/images/certificate/certificate-3.jpeg",
  },
];

// ---------------------------------------------------------------------------
// Static brand fields (SEO-critical, never edited via admin panel)
// ---------------------------------------------------------------------------
export const BRAND_STATIC = {
  name: BRAND.name,
  tagline: BRAND.tagline,
  logoUrl: BRAND.logoUrl,
  foundedYear: BRAND.foundedYear,
};
